import React, { useState, useEffect } from 'react';
import { Grid, Paper } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import moment from 'moment';
import { liveTrackinglayoutSelector } from '../../../features/layout/layoutSlice';
import { useSelector } from 'react-redux';

import { useTable } from 'react-table';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useTheme } from '@mui/material/styles';

import { Line } from 'react-chartjs-2';
import { Chart } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
Chart.register(annotationPlugin);
const colorList = ['Orange', 'Purple', 'DarkGreen', 'DarkSlateGray'];

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: 'Silver',
        color: useTheme().palette.common.black,
        fontSize: 13,
        fontStyle: 'bold'
    },
    body: {
        fontSize: 13,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: useTheme().palette.action.hover,
        },
    },
}))(TableRow);

const plotOptions = (min, max) => {
    return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                dispay: true,
                position: 'bottom',
                labels: {
                    fontSize: 12,
                    fontStyle: 'bold'
                }
            },
            annotation: {
                annotations: {
                    line1: {
                        type: 'line',
                        yMin: parseInt(min),
                        yMax: parseInt(min),
                        borderColor: 'Blue',
                        borderWidth: 1,
                        label: {
                            backgroundColor: 'DodgerBlue',
                            content: `Low: ${min} °C`,
                            enabled: true,
                        },
                    },
                    line2: {
                        type: 'line',
                        yMin: parseInt(max),
                        yMax: parseInt(max),
                        borderColor: 'FireBrick',
                        borderWidth: 1,
                        label: {
                            backgroundColor: 'Crimson',
                            content: `High: ${max} °C`,
                            enabled: true,
                        },
                    }
                }
            }

        },
        animation: { duration: 0 },
        elements: {
            point: {
                radius: 0
            }
        },
    }
};


const TemperatureLog = ({ reportData }) => {
    const dimentions = useSelector(liveTrackinglayoutSelector);

    const [plotData, setPlotData] = useState(null);
    const [tData, setTData] = useState([]);
    const [tCols, setTCols] = useState([{ Header: 'Time', accessor: 'time' }]);


    useEffect(() => {
        if (reportData.plotData && reportData.sensorNames) {
            let dsets = [];
            Object.keys(reportData.sensorNames).forEach((sens, index) => {
                dsets.push({
                    label: reportData.sensorNames[sens],
                    data: reportData.plotData.map(p => ({ x: p.time, y: p[reportData.sensorNames[sens]] })),
                    fill: false,
                    borderColor: colorList[index],
                    backgroundColor: colorList[index],
                    borderWidth: 1.5,
                    pointRadius: 1,
                })
            });
            //console.log("dataset", dsets);
            setPlotData({ datasets: dsets });


            if (reportData.reportRecords && reportData.reportRecords.length > 0) {
                const tdata = reportData.reportRecords.map(item => {
                    let itemObj = {
                        time: moment(item.time).format('D/M/Y hh:mm A'),
                        location: item.address.net_addr,
                    };
                    Object.keys(reportData.sensorNames).forEach(name => {
                        itemObj = {
                            ...itemObj,
                            [name]: !isNaN(parseFloat(item[reportData.sensorNames[name]])) ? `${parseFloat(item[reportData.sensorNames[name]]).toFixed(2)} °C` : item[reportData.sensorNames[name]],
                        }
                    })
                    return itemObj;
                })
                setTData(tdata);
            } else {
                setTData([]);
            }


            let cols = [{ Header: 'Time', accessor: 'time' }];
            Object.keys(reportData.sensorNames).forEach(name => {
                cols.push({ Header: reportData.sensorNames[name], accessor: name })
            })
            cols.push({ Header: 'Location', accessor: 'location' });
            setTCols(cols);
        }

        //console.log("Temp report", reportData);
    }, [reportData]);

    useEffect(() => {
        console.log("Temp valuesS", reportData);
        //console.log(reportData.dataTable);
    }, [reportData])


    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({ columns: tCols, data: tData });

    if (reportData.plotData && reportData.plotData.length > 0 && reportData.dataTable && reportData.reportRecords && reportData.reportRecords.length > 0 && reportData.sensorNames) {
        //if (reportData.dataTable && reportData.sensorNames) {
        //console.log("rendering", plotData);
        return (
            <Paper style={{ ...dimentions.reportDetailViewBottom, overflow: 'auto' }}>
                <div style={{ margin: '10px', marginRight: '5px' }}>
                    <Grid container spacing={1}>
                        <Grid item container sm={12}>
                            {
                                plotData && plotData.datasets && plotData.datasets.length > 0 &&
                                    <Line
                                        data={plotData}
                                        options={plotOptions(reportData.minTemp, reportData.maxTemp)}
                                    height={400}
                                />
                            }
                        </Grid>
                        <Grid item sm={12}>
                            <TableContainer component={Paper}>
                                <Table  {...getTableProps()}>
                                    <TableHead>
                                        {headerGroups.map(headerGroup => (
                                            <TableRow {...headerGroup.getHeaderGroupProps()}>
                                                {headerGroup.headers.map(column => (
                                                    <StyledTableCell
                                                        {...column.getHeaderProps()}
                                                    >
                                                        <b>{column.render('Header')}</b>
                                                    </StyledTableCell>
                                                ))}
                                            </TableRow>
                                        ))}
                                    </TableHead>
                                    <TableBody {...getTableBodyProps()}>
                                        {rows.map((row) => {
                                            prepareRow(row)
                                            return (
                                                <StyledTableRow {...row.getRowProps()}>
                                                    {row.cells.map(cell => {
                                                        return (
                                                            <StyledTableCell
                                                                {...cell.getCellProps()}
                                                            >
                                                                {cell.render('Cell')}
                                                            </StyledTableCell>
                                                        )
                                                    })}
                                                </StyledTableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </div>
            </Paper>
        );
    } else {
        return null;
    }


}

export default TemperatureLog;